import React, { useState, useEffect } from 'react';
import SearchParameters from './SearchParameters';
import ShipToDetailsCard from './ShipToDetailsCard';
import { useGetAuthrization } from '../home/redux/hooks';
import { redirectUrl } from '../../common/apiConfig';
import axios from '../../features/common/redux/interceptor.js';
import { useFetchShipToDetails, useResetShipToDetails } from './redux/hooks';
import './ShipToInquiry.less';
import {AUTH_ERROR_MSG, SIA_IA_STI_SEARCH_PARAMS_KEY} from '../../common/constants';

export default function ShipToInquiry() {
  const [hasSearched, setHasSearched] = useState(false);
  const { 
    shipToDetails, 
    fetchShipToDetails, 
    fetchShipToDetailsPending, 
    fetchShipToDetailsError 
  } = useFetchShipToDetails();
  const { resetShipToDetails } = useResetShipToDetails();
  const { auth } = useGetAuthrization();

  // Check for auth errors and redirect
  useEffect(() => {
    if (!auth.cognitoIdToken || fetchShipToDetailsError === AUTH_ERROR_MSG) {
      sessionStorage.clear();
      window.location.assign(redirectUrl);
    }
  }, [auth.cognitoIdToken, fetchShipToDetailsError]);

  // Auto-search with saved parameters on mount
  useEffect(() => {
    const savedParams = sessionStorage.getItem(`${SIA_IA_STI_SEARCH_PARAMS_KEY}_shipto`);
    if (savedParams) {
      try {
        const parsedParams = JSON.parse(savedParams);
        handleSearch(parsedParams);
      } catch (error) {
        console.error('Error loading saved search:', error);
      }
    }
  }, []); // eslint-disable-line

  const handleSearch = (values) => {
    console.log('ShipToInquiry - Search values:', values);
    const { site, shipToNumber } = values;
    
    setHasSearched(true);
    fetchShipToDetails({
      // siteNumber: site,
      siteNumber: String(site).split('-')[0].trim(),
      shipToNumber: shipToNumber,
    });

    // Save to session storage
    //sessionStorage.setItem(`${SIA_IA_STI_SEARCH_PARAMS_KEY}_shipto`, JSON.stringify(values));
  };

  const handleReset = () => {
    console.log('ShipToInquiry - handleReset');
    setHasSearched(false);
    resetShipToDetails(); // Clear data and error from Redux state
  };

  return (
    <div className="ship-to-inquiry">
      <SearchParameters type="shipto" onSearch={handleSearch} onReset={handleReset} />
      <div className="ship-to-details-section">
        <h3>Ship-To Information Details</h3>
        <ShipToDetailsCard 
          data={shipToDetails} 
          loading={fetchShipToDetailsPending}
          error={fetchShipToDetailsError}
          hasSearched={hasSearched}
        />
      </div>
    </div>
  );
}


